// Carregando e injetando as fontes
(() => {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "/portal/app/UI-EC/data/fonts.css";
  document.querySelectorAll("head")[0].appendChild(link);
})();

var appEC = angular.module("ui-ec-app", [
  "angular-chartist",
  "ngMap",
  "ngMessages",
  "ui.bootstrap",
  "ui.mask",
  "angular-loading-bar",
  "ngCpfCnpj",
  "ui-components-app",
  "ui-comum-app",
]);

appEC.factory("cnpjECInjector", [
  "sessionService",
  function (sessionService) {
    return {
      request: function (config) {
        if (!config.headers.cnpjEC) {
          var cnpjEC = sessionService.getCnpjEC();
          if (cnpjEC) {
            config.headers["cnpjEC"] = cnpjEC;
          }
        }
        return config;
      },
    };
  },
]);

// Factory Conta Digital - Onboarding
appEC.factory("ContaDigitalFactory", [
  "$rootScope",
  "$http",
  "sessionService",
  function ($rootScope, $http, sessionService) {
    // Verifica se o EC já tem uma Conta Digital
    function checkContaDigital() {
      const cnpjEC = sessionService.getCnpjEC();
      return new Promise((resolve) => {
        $http
          .get(`/api-web/cartaoec/onboarding/conta/${cnpjEC}`)
          .then(() => {
            // Se o resultado é 200, significa que ele já tem conta e então NÃO pode ter acesso ao Onboarding da Conta
            resolve(false);
          })
          .catch((err) => {
            // Se o resultado é 404, significa que ainda não tem conta, então PODE ver os dados do Onboarding da Conta
            if (err.status === 404) {
              resolve(true);
            } else {
              console.error("Erro ao consultar Conta Digital: ", err);
              resolve(false);
            }
          });
      });
    }

    return {
      checkContaDigital,
    };
  },
]);

appEC.factory("WarningsFactory", [
  "$rootScope",
  "$http",
  "$uibModal",
  "sessionService",
  function ($rootScope, $http, $uibModal, sessionService) {
    var $modalInstance,
      listaAvisos = [];
    return {
      startAvisos: getAvisos,
    };

    function getAvisos() {
      // Enquanto verificando, o $rootScope fica com a informação de que os avisos ainda não terminaram de ser exibidos
      $rootScope.avisosFinished = false;
      $http({
        method: "GET",
        url: "/portal/restricted/rest/vrpat/avisos-ec/",
        headers: {
          "Content-Type": "application/json",
        },
      }).then(function (response) {
        // Atualiza a lista de avisos
        listaAvisos =
          response && response.data && response.data.avisos
            ? response.data.avisos
            : [];

        // Se tem avisos a exibir
        if (listaAvisos.length) {
          // Inicia a exibição do primeiro aviso
          prepareModalData(listaAvisos[0]);
        } else {
          // Se não há o que exibir, informa ao rootScope o término deste fluxo
          avisosFinished();
        }
      });
    }

    // Executa a lista de avisos carregados do endpoint, eliminando o último visto e indo para o próximo
    function showNext() {
      listaAvisos.shift();
      if (listaAvisos.length) {
        prepareModalData(listaAvisos[0]);
      }
    }

    // Pega os dados do aviso, injeta função sendInterest e abre o aviso/modal
    function prepareModalData(data) {
      data.sendInterest = sendInterest;
      openModal(data);
    }

    // Função criada para informar ao $rootScope e demais componentes do app sobre o término de exibição dos avisos do EC
    function avisosFinished() {
      // Verifica se tem mais avisos a seguir
      const avisosCount = listaAvisos.length ? listaAvisos.length - 1 : 0;

      // Se não há mais o que exibir
      if (!avisosCount) {
        // Atualiza a informação no $rootScope
        $rootScope.avisosFinished = true;
        // e emite o evento de que os avisos terminaram
        $rootScope.$broadcast("EventAvisosFinished", true);
      }
    }

    function openModal(data) {
      if (data.campanha === "cartao_compras_natal_2018") {
        var result = JSON.parse(
          sessionStorage.getItem(constants.EVENTS.ESTABLISHMENT_ACTIVATED)
        );
        if (result.avisoCartoesComprasNatal) {
          avisosFinished();
          return false;
        }
      }

      var modalSize = data.campanha === "boas-vindas-sva" ? "lg" : "md";

      $modalInstance = $uibModal.open({
        templateUrl:
          "/portal/app/UI-EC/partials/modals/" + data.campanha + ".html",
        controller: "ModalCtrl",
        size: modalSize,
        backdrop: "static",
        keyboard: false,
        resolve: {
          data: function () {
            return data;
          },
        },
      });
    }

    function sendInterest(option, campanhaId, url) {
      $http({
        method: "PUT",
        url: "/portal/restricted/rest/vrpat/avisos-ec/" + campanhaId + "/opcao",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          tipoOpcao: option.toString(),
          cnpjEC: sessionService.getCnpjEC(),
        },
      }).then(function (response) {
        closeModal(response, option, url);
      });
    }

    function redirect(url) {
      window.location.assign(url);
    }

    function closeModal(response, option, url) {
      // Ao fechar o aviso, verifica se acabaram os avisos para informar ao rootScope
      avisosFinished();

      if (option == 2) {
        if (url) {
          redirect(url);
          return false;
        }
      }

      $modalInstance.dismiss();

      if (listaAvisos.length) {
        showNext();
      }
    }
  },
]);

appEC.config([
  "$httpProvider",
  function ($httpProvider) {
    $httpProvider.interceptors.push("cnpjECInjector");
  },
]);

function assetsPortal() {
  const { hostname } = window.location;

  let envPath = "";
  if (hostname.indexOf("localhost") > -1) {
    envPath = "-dev";
  } else if (hostname.indexOf("dsp.") > -1) {
    envPath = "-dev";
  } else if (hostname.indexOf("hmp.") > -1) {
    envPath = "-qa";
  }

  return {
    ASSETS_PORTAL: `https://assets${envPath}.vr.com.br/portalrh`,
  };
}

const env = { ...assetsPortal() };

appEC.factory("BannerFactory", [
  "$rootScope",
  "$http",
  function ($rootScope, $http) {
    function getBannersData() {
      $rootScope.bannerDataLoading = false;
      console.log(env);
      $http
        .get(`${env.ASSETS_PORTAL}/vrpat/data/ec/banners.json`)
        .then(function (response) {
          response = response || {};

          $rootScope.bannerDataLoading = true;
          $rootScope.bannerData = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    return {
      start: getBannersData,
    };
  },
]);

appEC.run([
  "$rootScope",
  "sessionService",
  "$window",
  "$http",
  "WarningsFactory",
  "BannerFactory",
  function (
    $rootScope,
    sessionService,
    $window,
    $http,
    WarningsFactory,
    BannerFactory
  ) {
    $rootScope.isInProfile = function () {
      return $window.location.pathname.indexOf("estabelecimento.html") > -1;
    };

    // codigo para verificar se o ec escolheu o painel novo ou antigo
    const isOldVersion = localStorage.getItem("VR.SurveyOld");
    const isClosed = sessionStorage.getItem("VR.Survey");

    $rootScope.isSurveyOpen = true;

    if (isOldVersion !== "oldversion") {
      $rootScope.isOldVersion = false;

      if (
        window.location.pathname ===
        "/portal/portal-vr/area-restrita/vr-e-estabelecimentos/"
      ) {
        window.location.assign("/apps/ec/painel");
      }
    }

    if (isOldVersion === "oldversion" && isClosed === "closed") {
      $rootScope.isOldVersion = true;
      $rootScope.isSurveyOpen = false;
    }

    var hasActiveEstablishment = $rootScope.hasActiveEstablishment();
    if (hasActiveEstablishment) {
      WarningsFactory.startAvisos();
      isActivePromotionMenu();
      BannerFactory.start();
    }

    $rootScope.$on(constants.EVENTS.ESTABLISHMENT_ACTIVATED, function (data) {
      WarningsFactory.startAvisos();
      isActivePromotionMenu();
      BannerFactory.start();

      //Script do Wootric para Pesquisa de Marketing
      // let cnpj = JSON.parse(
      //   sessionStorage.getItem("Establishment.activated")
      // ).cnpj;
      // window.wootricSettings = {
      //   email: getCookie('lumUserLogin').split('#')[1] .replace('"',''), // NOTA: Substituir pela variável de email do usuário logado.
      //   external_id: cnpj,
      //   created_at: +new Date,
      //   account_token: 'NPS-9fd65411'
      // };

      // window.wootric('run');
    });

    function isActivePromotionMenu() {
      var cnpj = sessionService.getCnpjEC();

      if (cnpj === undefined) {
        $rootScope.showPromotion = false;
        if ($window.location.pathname.indexOf("promocoes.html") > -1) {
          $window.href = "./";
        }
      } else {
        $rootScope.showPromotion = true;

        if (!$rootScope.showPromotion) {
          if ($window.location.pathname.indexOf("promocoes.html") > -1) {
            $window.location.href = "./";
            window.test = $window;
          }
        }

        $rootScope.$broadcast("EventLoadPromotions", true);
        // $http
        //   .get("/api-web/ec/v1/estabelecimento/habilitado?cnpj=" + cnpj)
        //   .then(function (result) {
        //     // A pedido de negócios, EPE-1136, deve-se ignorar essa regra
        //     // e sempre exibir o menu promoções para todos os EC's.
        //     // $rootScope.showPromotion = result.data.habilitado;
        //     $rootScope.showPromotion = true;

        //     if (!$rootScope.showPromotion) {
        //       if ($window.location.pathname.indexOf("promocoes.html") > -1) {
        //         $window.location.href = "./";
        //         window.test = $window;
        //       }
        //     }
        //     $rootScope.$broadcast("EventLoadPromotions", true);
        //   });
      }
    }
  },
]);
